import { Component, OnInit, Input } from '@angular/core';
import { UserModel } from 'src/app/models/userModel';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {

  @Input() user: UserModel;
  constructor() { }

  ngOnInit() {
  }

}
